import {
  ListNotificationsFilterParameterStatusAnyOfInner as NotificationStatus,
  NotificationType
} from "@wingspanhq/wingspan-api-sdk";
import { WSNotificationResponse } from "../../modules/Dashboard/components/Notifications";

export const selectorCountOfVisibleNotifications = (
  responses: WSNotificationResponse[]
) => {
  return (
    responses.filter(response => {
      // Only count non-dismissable notifications that haven't been dismissed
      // This matches the todo list logic which excludes all dismissable notifications
      return (
        response.type === NotificationType.NON_DISMISSABLE &&
        response.status !== NotificationStatus.DISMISSED
      );
    }).length || 0
  );
};
